import { render, staticRenderFns } from "./DiagnosticScreen.vue?vue&type=template&id=2a67016a&scoped=true"
import script from "./DiagnosticScreen.vue?vue&type=script&lang=ts"
export * from "./DiagnosticScreen.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosticScreen.vue?vue&type=style&index=0&id=2a67016a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67016a",
  null
  
)

export default component.exports